import { observer } from "mobx-react-lite"
import { useQuery } from "@tanstack/react-query"

import { useApiService } from "@/hooks/use-api-service"
import { useChainConfig } from "@/hooks/use-chain-config"

import type { VolumeDataItem } from "@/domains/landing-page/components/volume-chart"
import { VolumeView } from "./volume-view"

// @todo MIGRATE: Move volume data fetching to MobX store with OrchestratedQuery
export const VolumeComposite = observer(() => {
  const chainConfig = useChainConfig()
  const apiService = useApiService()

  const chainSlug = chainConfig.slug

  const datasetQuery = useQuery({
    queryKey: ["analytics-volume", chainSlug],
    queryFn: async () => {
      try {
        // eslint-disable-next-line @typescript-eslint/no-unsafe-assignment
        const response = await apiService.getV4VolumeAnalytics()

        return response as Array<VolumeDataItem>
      } catch (error) {
        console.error("Error fetching volume analytics data", error)
      }
    },
  })

  return (
    <VolumeView data={datasetQuery.data} isLoading={datasetQuery.isLoading || !datasetQuery.isFetched} />
  )
})
